import { PortalType } from '@studyportals/domain-client';
import { MappedKeyword } from '../../keyword-helper/enums/MappedHelperKeyword';
import { KeywordHelperContent } from '../../keyword-helper/KeywordHelperContent';
import MoreSpecificBachelorsDefinition from './be-more-specific/MoreSpecificBachelorsDefinition';
import MoreSpecificMastersDefinition from './be-more-specific/MoreSpecificMastersDefinition';
import MoreSpecificPhdDefinition from './be-more-specific/MoreSpecificPhdDefinition';
import EnglishCourseDefinition from './english-helper/EnglishCourseDefinition';
import WrongPortalBachelorsDefinition from './wrong-portal/WrongPortalBachelorsDefinition';
import WrongPortalMastersDefinition from './wrong-portal/WrongPortalMastersDefinition';
import WrongPortalPhdDefintion from './wrong-portal/WrongPortalPhdDefinition';

export class KeywordHelperDefinitionHelper {
	public getKeywordContent(portal?: PortalType, keyword?: MappedKeyword): KeywordHelperContent | undefined {
		if (keyword === MappedKeyword.ENGLISH && portal !== PortalType.SHORT) {
			return EnglishCourseDefinition;
		}

		if (keyword === MappedKeyword.MASTERS && portal === PortalType.MASTER) {
			return MoreSpecificMastersDefinition;
		}

		if (keyword === MappedKeyword.MASTERS && portal !== PortalType.MASTER) {
			return WrongPortalMastersDefinition;
		}

		if (keyword === MappedKeyword.BACHELORS && portal === PortalType.BACHELOR) {
			return MoreSpecificBachelorsDefinition;
		}

		if (keyword === MappedKeyword.BACHELORS && portal !== PortalType.BACHELOR) {
			return WrongPortalBachelorsDefinition;
		}

		if (keyword === MappedKeyword.PHD && portal === PortalType.PHD) {
			return MoreSpecificPhdDefinition;
		}

		if (keyword === MappedKeyword.PHD && portal !== PortalType.PHD) {
			return WrongPortalPhdDefintion;
		}
	}
}
